import { ReturnReasonSchema } from "@redotech/redo-model/agents/returns-agents/exchange-agent/return-reasons";
import { ReturnProductSchema } from "@redotech/redo-return-core-common/draft-return/draft-return-items";
import { ProductDataSchema } from "@redotech/redo-return-operations-common/customer-portal/product";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

// Birdy Grey's external exchange recommendations — an ordered product list.
export const getBirdyGreyExchangeRecommendations = unaryRpc({
  name: "getBirdyGreyExchangeRecommendations" as const,
  input: z.object({
    draftReturnId: z.string(),
    returnProduct: ReturnProductSchema,
    returnReasons: z.array(ReturnReasonSchema),
    locale: z.string().optional(),
  }),
  output: z.object({
    recommendedProducts: z.array(
      z.object({
        product: ProductDataSchema,
        recommendedOptions: z.array(
          z.object({ optionName: z.string(), optionValue: z.string() }),
        ),
      }),
    ),
  }),
});
